import GuideMessage from "../components/GuideMessage";

const LibraryGuideMessage = ({
    isAdmin
}) => {
    return (
        <GuideMessage>
            <li>1. Si deseas hacer un registro, debes desplegar el botón <b>Registrar recurso</b> y elegir la opción que desees.</li>
            <li>2. Si deseas visualizar los recursos registrados previamente, <b>debes completar todos los campos del filtro de búsqueda</b> y hacer clic en Aplicar.</li>
            {isAdmin && 
            <li>
                3. Si deseas editar los horarios de una biblioteca o visualizar todos los recursos registrados en dicha biblioteca, debes ingresar a <b>Configuración {"->"} Administrador de Bibliotecas.</b>
            </li>}
        </GuideMessage>
    );
}

export default LibraryGuideMessage;